import validators from '../../utils/validators';
import QuestionnaireField from './field';

class QuestionnaireQuestion {
  /**
   * @param data
   */
  constructor(data) {
    const properties = {
      id: (v) => validators.isNotEmptyString(v),
      text: (v) => validators.isNotEmptyString(v),
      multiple: (v) => validators.isBoolean(v),
      type: (v) => validators.isNotEmptyString(v),
      gender: (v) => validators.isNotEmptyString(v),
      sort: (v) => validators.isNumber(v),
    };

    for (const property of Object.keys(properties)) {
      if (properties[property](data[property]) !== true) {
        throw new Error(`Invalid QuestionnaireQuestion property '${property}' in ${data.id}`);
      }

      this[property] = data[property];
    }

    this.fields = [];

    if (Array.isArray(data.fields)) {
      for(const field of data.fields) {
        this.fields.push(new QuestionnaireField(field));
      }
    }
  }
}

export default QuestionnaireQuestion;
